module.exports = __webpack_public_path__ + "img/PT22.1036cea0.png";